import React from "react";
import Enrolment from "../Enrolment";

const EnrolledCompletedComponent = () => {
  return <Enrolment status="completed" title="completed" />;
};

export default EnrolledCompletedComponent;
